import { AccountType } from '@/common/types'
import { APPLICATION_COPY } from '@/locales/en'
import { ApplicationAccountTypeStep } from '../../../components/ApplicationAccountTypeStep'

type Props = {
    selectedAccountType: AccountType | null
    setSelectedAccountType: (accountType: AccountType | null) => void
    isTrust: boolean
    setIsTrust: (isTrust: boolean) => void
    supportedAccountTypes: AccountType[]
    isAdviser: boolean
}

export function AddAccountTypeSelectionStep({
    selectedAccountType,
    setSelectedAccountType,
    isTrust,
    setIsTrust,
    supportedAccountTypes,
    isAdviser,
}: Props) {
    return (
        <ApplicationAccountTypeStep
            title={APPLICATION_COPY.accountType.title}
            description={
                isAdviser ? APPLICATION_COPY.accountType.adviserDescription : APPLICATION_COPY.accountType.description
            }
            selectedAccountType={selectedAccountType}
            setSelectedAccountType={setSelectedAccountType}
            isTrust={isTrust}
            setIsTrust={setIsTrust}
            supportedAccountTypes={supportedAccountTypes}
            showDisabledTrustOption={isAdviser}
            showDisabledCompanyOption={isAdviser}
            disabledOptionBadgeText={APPLICATION_COPY.accountType.comingSoonLabel}
            useThirdPersonCopy={isAdviser}
        />
    )
}
